import { render, staticRenderFns } from "./Matcher.vue?vue&type=template&id=3950eac2"
import script from "./Matcher.vue?vue&type=script&lang=js"
export * from "./Matcher.vue?vue&type=script&lang=js"
import style0 from "./Matcher.vue?vue&type=style&index=0&id=3950eac2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports